import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import App from "./App";
import { store } from "../app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "../serviceWorker";
import config from "../utils/config";
import { datadogRum } from "@datadog/browser-rum";

import "@datadog/browser-logs/bundle/datadog-logs";
import { v4 as uuidv4 } from "uuid";
import { datadogBeforeSend } from "../utils/datadogUtils";

const sessionId = uuidv4();
window.DD_LOGS.init({
  clientToken: "pub1d59da4c25366700f41680a4272a4353",
  site: "us5.datadoghq.com",
  service: "corporate-travel-portal",
  version: config.REACT_APP_VERSION,
  env: config.ENV.toLowerCase(),
  sessionSampleRate: 100,
  telemetrySampleRate: 100,
  forwardConsoleLogs: "all",
  trackInteractions: true,
  beforeSend: (log: any) => {
    log.browser_session_id = sessionId;
    log.path = window.location.pathname;
  },
});

datadogRum.init({
  applicationId: '4f8c9e1d-cdb2-49a1-b995-25c40370fa3a',
  clientToken: 'pub1d59da4c25366700f41680a4272a4353',
  site: "us5.datadoghq.com",
  service: "corporate-travel-portal",
  env: config.ENV.toLowerCase(),
  sessionSampleRate: config.ENV.toLowerCase() === "production" ? 70 : 100,
  sessionReplaySampleRate: config.SESSION_REPLAY_SAMPLE_RATE,
  version: config.REACT_APP_VERSION,
  trackUserInteractions: false,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask",
  allowedTracingUrls: [
    "https://corporate-travel-portal.development.capone.h4r.io/",
    "https://businesstravel-qa.capitalone.com/",
    "https://businesstravel.capitalone.com/",
    "http://localhost:3003",
  ],
  beforeSend: datadogBeforeSend,
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
